import { IModelOpinion } from '../dataModels/ProductModels';
import * as style from './style.css';
import { ApplicationContext } from '../../../framework/framework/shared/ApplicationContext';
import StarIcon from '../../../assets/icons/Star';
import { StarBorder } from '@material-ui/icons';
import TextInput from '../../../components/textInput/TextInput';
import TextAreaInput from '../../../components/textAreaInput/TextAreaInput';
import { ActionT } from '../../../framework/framework/components/Types';
import ActionButton from '../../../components/actionButton/ActionButton';
import React = require('react');

interface IProps {
    opinions: IModelOpinion[];
    appCtx: ApplicationContext;
    reviewFormOpen: boolean;
    onAddReview:ActionT<IModelOpinion>;
}

interface IState {
    formData: IModelOpinion;
    errors:any;
}

export default class ModelOpinions extends React.Component<IProps, IState> {
    constructor(props:IProps) {
        super(props);
        this.state = {
            formData: { author: '', description: '', score: 5, productId: 0, date: '' },
            errors: {}
        };
    }

    render() {
        return (
            <div className={style.opinionsWrapper}>
                {this.props.reviewFormOpen
                    ? this.reviewForm()
                    : <div className={style.opinions}>
                        {this.props.opinions.map((p, i) => this.opinions(p, i))}
                    </div>
                }
            </div>
        );
    }

    reviewForm(): React.ReactNode {
        const textStyle = { margin: '7px' };
        const formData = this.state.formData;
        return <>
            <div style={textStyle}>
                {this.getStarsInterActive(this.state.formData.score)}

            </div>
            <div style={textStyle}>
                <TextInput
                    key={'author'}
                    value={formData.author}
                    onChange={(s: string) => this.onValueChange('author', s)}
                    onKeyDown={() => { }}
                    placeholder="imię/login"
                    errors={this.state.errors.author || []} />
            </div>
            <div style={textStyle}>
                <TextAreaInput
                    key={'description'}
                    value={formData.description}
                    onChange={(s: string) => this.onValueChange('description', s)}
                    onKeyDown={() => { }}
                    placeholder="Twoja opinia *"
                    errors={this.state.errors.content || []} />
            </div>
            <div style={textStyle}>
                <ActionButton
                    label="Wyślij"
                    onClick={() => this.onSendReviewClick()}
                >
                </ActionButton>
            </div>
        </>;
    }

    onSendReviewClick(): void {
        const formData = this.state.formData;
        if (this.props.onAddReview) { this.props.onAddReview(formData); }
    }

    onValueChange(arg0: string, s: string) {
        const form = this.state.formData;
        form[arg0] = s;
        this.setState({ formData: form });
    }

    opinions(p: IModelOpinion, i: number): JSX.Element {
        return <div key={i} className={style.row}>
            <div className={style.author}>
                {p.author}
                <span className={style.light}>
                    {p.date}
                </span>
            </div>
            <div className={style.content}>
                <div className={style.score}>
                    {this.getStars(p.score)}
                    <span className={style.light}>
                        Ocena:
                    </span>
                    {p.score}

                </div>
                <div className={style.description}>
                    {p.description}
                </div>
            </div>
        </div>;
    }

    getStars(score: number): JSX.Element {
        const stars = [];
        for (let i = 0; i < 5; i++) {
            if (i < score) {
                stars.push(<StarIcon key={i}/>);
            } else {
                stars.push(<StarBorder key={i}/>);
            }
        }
        return <div className={style.stars}>
            {stars}
        </div>;
    }

    getStarsInterActive(score: number):JSX.Element {
        const stars = [];
        let star = null;
        for (let i = 0; i < 5; i++) {
            if (i < score) {
                star = <StarIcon />;
            } else {
                star = <StarBorder />;
            }

            stars.push(<div onClick={() => this.onStartClick(i) }>{star}</div>);
        }
        return <div className={style.starsInteractive}>
            {stars} {score}
        </div>;
    }

    onStartClick(i: number): void {
        const form = this.state.formData;
        form.score = i + 1;
        this.setState({ formData: form });
    }
}
